import 'core-js/es6/map';
import 'core-js/es6/set';
import 'core-js/fn/array/includes';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { injectGlobal } from 'styled-components';
import AppState from './containers/App/AppState';
import App from './containers/App/App';
import { unregister } from './registerServiceWorker';
import './assets/fonts';

injectGlobal`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
`;

ReactDOM.render(
  <BrowserRouter>
    <AppState>
      <App />
    </AppState>
  </BrowserRouter>, document.getElementById('root'));
    
// registerServiceWorker();
unregister();


// WEBPACK FOOTER //
// ./src/index.js